/**
 * Social-share card (og:image) for a calendar page, from the image renderer's
 * calendar-card mode at 1200x630.
 *
 * @param endpoint - Image renderer endpoint.
 * @param calendarId - Calendar id.
 * @returns Image URL, or undefined without an endpoint or id.
 */
export function calendarSocialImageUrl(endpoint, calendarId) {
    if (!calendarId || !endpoint)
        return undefined;
    return `${endpoint}?calendarId=${calendarId}&size=large`;
}
//# sourceMappingURL=socialImage.js.map